import styles from './StatusBadge.module.css';

const creatorActionMap: Record<string, [string, string]> = {
  'Follow Up': [styles.followUp, 'Follow Up'],
  'Needs Response': [styles.needsResponse, 'Needs Response'],
  Approved: [styles.approved, 'Approved'],
  Cut: [styles.cut, 'Cut'],
  Contracted: [styles.contracted, 'Contracted'],
  'In Negotiation': [styles.inNegotiation, 'In Negotiation'],
  'Ready for Onboarding Form': [styles.readyOnboarding, 'Ready for Onboarding Form'],
};

const intakeMap: Record<string, [string, string]> = {
  pending_review: [styles.iPending, 'Pending Review'],
  ready_for_contract: [styles.iReadyContract, 'Ready for Contract'],
  rejected: [styles.iRejected, 'Rejected'],
  pending_signature: [styles.iPendingSig, 'Pending Signature'],
  contract_rejected: [styles.iContractRejected, 'Contract Rejected'],
  contract_signed: [styles.iContractSigned, 'Contract Signed'],
};

const videoMap: Record<string, [string, string]> = {
  awaiting_submission: [styles.vAwaiting, 'Awaiting Submission'],
  under_review: [styles.vReview, 'Under Review'],
  revisions_requested: [styles.vRevisions, 'Revisions Requested'],
  approved: [styles.vApproved, 'Approved'],
  published: [styles.vApproved, 'Published'],
};

export function CreatorActionBadge({ status }: { status?: string }) {
  if (!status) return <span>—</span>;
  const [cls, label] = creatorActionMap[status] ?? ['', status];
  return <span className={`${styles.badge} ${cls}`}>{label}</span>;
}

export function IntakeStatusBadge({ status }: { status?: string }) {
  const [cls, label] = intakeMap[status ?? ''] ?? [styles.iPending, 'Pending Review'];
  return <span className={`${styles.badge} ${cls}`}>{label}</span>;
}

export function VideoStatusBadge({ status }: { status?: string }) {
  const [cls, label] = videoMap[status ?? ''] ?? [styles.vAwaiting, 'Awaiting Submission'];
  return <span className={`${styles.badge} ${cls}`}>{label}</span>;
}
